
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { saveAs } from 'file-saver'
import setting from '@/settings'
import { getHelpList, getHelpListCount, detail } from '@/api/help'
import dayjs from 'dayjs'
@Component({
  name: 'help-list',
  components: {
    SimpleTable,
    DictSelect
  }
})
export default class HelpList extends Vue {
  private form = {
    state: 1
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'title',
    label: '标题'
  },
  // {
  //   prop: 'isTopName',
  //   label: '是否置顶'
  // },
  {
    prop: 'createName',
    label: '创建人'
  },
  {
    prop: 'createTime',
    label: '创建时间',
    format: 'date'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const form = util.trimForm({ ...this.form })
    !pagination && (this.pagination.currentPage = 1)
    await getHelpList({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      await getHelpListCount({
        ...form
      }).then((resCnt: any) => {
        this.loading = !1
        this.tableData.list = res.object.list
        this.tableData.totalCount = resCnt.object.totalCount
      }).catch((err: any) => {
        console.log('err', err)
        this.loading = !1
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  get isEmpty () {
    return this.detailData.content.replace(/<[^>]*>|/g, '').trim().length < 1
  }

  private onReset () {
    this.form = {
      state: 1
    }
    this.onQuery()
  }

  private currentPage = 1

  private visible = !0

  private detailData: any = {}

  private async showDetail (row: any) {
    await detail({ id: row.id }).then((res: any) => {
      if (res.code === 10000) {
        this.visible = !1
        this.detailData = {
          id: res.object.help.id,
          title: res.object.help.title,
          content: res.object.help.content,
          createName: res.object.help.createName,
          isTopName: res.object.help.isTopName,
          createTime: dayjs(res.object.help.createTime).format('YYYY-MM-DD'),
          stateName: res.object.help.stateName,
          helpAtts: res.object.help.helpAtts
        }
      }
    })
  }

  private async downLoad (file: any) {
    saveAs(setting.ossIp + '/' + file.path, file.realName)
    // await fileDownPost({
    //   filePath: file.path,
    //   fileName: file.realName
    // }).then((res: any) => {
    //   saveAs(res, 'file.realName')
    // })
  }

  mounted () {
    this.onQuery()
  }
}
